import { useMutation } from '@tanstack/react-query';
import { api } from 'src/constants/apiRoutes';
import axiosInstance from 'src/utils/axios';

interface DeletePoLineItemRequest {
  poId: number;
  lineItemId: number;
  poGridId?: number;
}

interface UseDeletePoLineItemMutationOptions {
  onSuccess?: () => void;
  onError?: (error: any) => void;
}

const useDeletePoLineItemMutation = ({
  onSuccess,
  onError,
}: UseDeletePoLineItemMutationOptions = {}) => {
  const mutation = useMutation({
    mutationFn: async ({ poId, lineItemId, poGridId }: DeletePoLineItemRequest) => {
      const response = await axiosInstance.delete(api.deletePoLineItem(poId, lineItemId, poGridId));
      return response.data;
    },
    onSuccess: (_data) => {
      onSuccess?.();
    },
    onError: (error) => {
      onError?.(error);
    },
  });

  return mutation;
};

export default useDeletePoLineItemMutation;
